import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { NotificationContainer } from 'react-notifications'

import WelcomeComponent from './welcome_component'
import CCPopupsContainer from '../containers/cc_popups_container'
import CustomerFilterContainer from '../containers/customer_filter_container'
import CustomerActionsContainer from '../containers/customer_actions_container'
import CategoriesFiltersContainer from '../containers/categories_filters_container'
import SalesDemoContentContainer from '../containers/sales_demo/sales_demo_content_container'
import CustomerCenterContentContainer from '../containers/customer_center_content_container'
import CCPopupsContainerSimGolf from '../containers/sim_golf/cc_popups_container_sim_golf'

const CustomerCenterComponent = (props) => {
  const [isChecked, setIsChecked] = useState(false)
  const [listView, setListView] = useState(true)
  const [calendarView, setCalendarView] = useState(false)

  useEffect(() => {
    if (props.shouldLoadData) {
      props.fetchData(props.shouldLoadInitialDataForListView ? props.filters : null)
    }
  }, [])

  useEffect(() => {
    setListView(listView)
  }, [listView])

  useEffect(() => {
    setCalendarView(calendarView)
  }, [calendarView])

  return (
    <Fragment>
      { !props.isSalesDemo ?
        <Fragment>
          { !props.isSimGolf && <CustomerFilterContainer /> }
          <Row>
            <Col xs={ true }>
              <CustomerActionsContainer />
            </Col>
          </Row>
          { !props.showWelcome ? (
            <Fragment>
              <Row className={`categories-filters-wrapper ${ props.isSimGolf ? 'categories_filters_wrapper_sim_golf' : '' }`}>
                <Col xs={ true } className='categories_filters_container'>
                  <CategoriesFiltersContainer
                    setListView={ setListView }
                    setCalendarView={ setCalendarView }
                    listView={ listView }
                    calendarView={ calendarView }
                    isChecked={ isChecked }
                    setIsChecked={setIsChecked}
                  />
                  <span className='hr_container hidden-sm hidden-xs'><hr /></span>
                </Col>
              </Row>
              <Row>
                <Col xs={ true } className='no-padding'>
                  <CustomerCenterContentContainer
                    listView={ listView }
                    calendarView={ calendarView }
                    isChecked={ isChecked }
                    setIsChecked={ setIsChecked }
                  />
                </Col>
              </Row>
            </Fragment>) :
            <WelcomeComponent />}
        </Fragment> : (
        <Fragment>
          <Row>
            <Col xs={ true }>
              <CustomerActionsContainer />
            </Col>
          </Row>
          <Row>
            <Col xs={ true }>
              <SalesDemoContentContainer />
            </Col>
          </Row>
      </Fragment>)}
      {props.isSimGolf ? <CCPopupsContainerSimGolf /> : <CCPopupsContainer />}
      <NotificationContainer />
    </Fragment>
  )
}

CustomerCenterComponent.propTypes = {
  isSalesDemo: PropTypes.bool,
  shouldLoadData: PropTypes.bool.isRequired,
  shouldLoadInitialDataForListView: PropTypes.bool,
  showWelcome: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
  filters: PropTypes.object,
}

export default CustomerCenterComponent